import React from 'react';
import { ComponentConfig } from '../../interface/interface';
import { componentTypes, Schema } from '@data-driven-forms/react-form-renderer';
import { GridProps } from '@mui/system';

export interface AttributeValueSchemaData {
  attributeName: string,
  attributeId: string,
  editData?: any,
}

export const AttributeValueSchema = (props: AttributeValueSchemaData) => {
  const {
    attributeName,
    attributeId,
    editData,
  } = props;
  return {
    fields: [
      {
        component: componentTypes.TEXT_FIELD,
        label: `Attribute Value for ${attributeName}`,
        placeholder: 'Value',
        name: 'attributeValue',
        required: true,
        disabled: false,
        initialValue: editData?.value,
        validate: [{
          type: 'required',
          message: 'Attribute value is required'
        }]
      }
    ]
  } as Schema extends GridProps ? GridProps : never;
};
